// markPageSaved — the page's save SUCCEEDED: every shared field-kit control in
// it takes its current value as the loaded one and is no longer unsaved
// (FIELD-KIT DIRTY, shared AppField.js; perf/shell-keepalive 2026-10-10).
//
//   el.call('markPageSaved', pageOrFormEl)   // or with `this` = that element
//
// Call it ONLY after the save resolved. A failed save does not call it, so the
// controls keep declaring unsaved work and the keep-alive cap / split-pane
// replace still ask "Discard changes?" for the page. Returns how many controls
// it cleared.
export function markPageSaved(container) {
  const LIMIT = 20000
  const root = container || this
  if (!root || typeof root !== 'object') return 0
  const stack = [root]
  let seen = 0
  let cleared = 0
  while (stack.length && seen < LIMIT) {
    const el = stack.pop()
    seen++
    if (!el || typeof el !== 'object') continue
    if (el.__kitTouched && el.scope && typeof el.scope.kitSaved === 'function') {
      el.scope.kitSaved(el)
      cleared++
    }
    const kids = el.__ref && el.__ref.__children
    if (!Array.isArray(kids)) continue
    for (const k of kids) {
      const child = typeof k === 'string' ? el[k] : k
      if (child && typeof child === 'object' && child !== el) stack.push(child)
    }
  }
  return cleared
}
